import { useEffect, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';

export default function GroupTestsWidget({ groupId, refresh }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get('/api/students?groupe=' + groupId, { withCredentials: true })
      .then(response => {
        const students = response.data || [];
        Promise.all(students.map(student =>
          axios.get('/api/conversationprogress?student=' + student.id + '&isForMe=1', { withCredentials: true })
            .then(r => ({ student, progresses: r.data || [] }))
            .catch(() => ({ student, progresses: [] }))
        )).then(setRows);
      })
      .catch(() => setRows([]));
  }, [groupId, refresh]);

  const lang = language[language.lang];

  return (
    <div className="group-card-section">
      <h4 className="group-card-section-title">{lang.groupCard.testsTitle}</h4>
      {rows.length === 0 ? (
        <p className="group-attendance-empty">{lang.groupCard.noTests}</p>
      ) : (
        <ul className="group-tests-list">
          {rows.map(({ student, progresses }) => {
            const finished = progresses.filter(p => p.isFinished === 1).length;
            const pending = progresses.length - finished;
            return (
              <li className="group-tests-row" key={student.id}>
                <span className="group-tests-name">{student.name} {student.surname}</span>
                <span className="group-tests-counts">
                  <span className="conv-participant-status done">{finished} {lang.isFinished}</span>
                  {pending > 0 ? (
                    <span className="conv-participant-status pending">{pending} {lang.groupCard.pendingStatus}</span>
                  ) : ''}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
